var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_31200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7109 0H3.59766C2.88672 0 2.30859 0.578125 2.30859 1.28906C2.30859 2 2.88672 2.57812 3.59766 2.57812H15.5938L0.378906 17.7969C-0.125 18.3008 -0.125 19.1172 0.378906 19.6211C0.882812 20.125 1.69922 20.125 2.20312 19.6211L17.418 4.40234V16.3984C17.418 17.1094 17.9961 17.6875 18.707 17.6875C19.418 17.6875 19.9961 17.1094 19.9961 16.3984V1.28906C20 0.578125 19.4219 0 18.7109 0Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_31200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossArrow);
export default __webpack_public_path__ + "static/media/Cross-Arrow.d2638e670a212f7924e56cdecd1960cb.svg";
export { ForwardRef as ReactComponent };